//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, } from 'vuex'
import { request } from 'http';
export default {
    name: 'nHeader',
    data () {
        return {
            sec:require('../assets/images/personBg.png'),
            showBack1: true,
            designer1: false,
            setUpShop1: false,
            headsServiceShow:false,
            headerFlag: '',
            headPhoneShow:false,
            userData:'',
            isLogin:false,
            cartSize:0,
            userImg : this.$common.getCookie('_userImg')
        }
    },
    props: ['showBack', 'designer', 'setUpShop','headsService','headPhone'],
    mounted () {
        this.showBack == undefined ? this.showBack1 = true : this.showBack1 = false
        this.designer == true ? this.designer1 = true : this.designer1 = false
        this.setUpShop == true ? this.setUpShop1 = true : this.setUpShop1 = false
        this.headsService == true ? this.headsServiceShow = true : this.headsServiceShow = false
        this.headerFlag = this.$route.name
        this.headPhone == true ? this.headPhoneShow = true : this.headPhoneShow = false
    },
    watch: {
        $route (to, from) {
            this.headerFlag = to.name
            this.userImg = this.$common.getCookie('_userImg')
            console.log(this.userImg);
            if(this.userImg) {
                this.getCartSize()
            }else{
                this.cartSize = 0
            }
            // console.log(this.$token);
            // if(this.$token) {
            //     this.isLogin = true
            //     if(this.getCookie('_userImg')) {
            //         this.userImg = this.getCookie('_userImg')
            //     }
            // }
            // console.log(this.getterUserData());
            // if(this.getterUserData()) {
            //     this.isLogin = true
                
            //     this.userData = this.getterUserData()
            // }else{
            //     this.isLogin = false
            // }
        }
    },
    methods: {
        ...mapGetters ([
			'getterUserData'
		]),
        getCookie(name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return null;
        },
        back () {
            this.$router.go(-1)
        },
        homePage () {
            this.$router.push({
                path: '/'
            })
        },
        more () {
            this.$router.push({
                path: '/more'
            })
        },
        stylist () {
            this.$router.push({
                path: '/stylist'
            })
        },
        myStore () {
            this.$router.push({
                path: '/myStore'
            })
        },
        customization () {
            console.log(1)
        },
        getCartSize() {
            //获取购物车数量
            this.$request.post('/cart/getCartSize',{
                token: this.getCookie('_token')
            }).then(data => {
                if(data.code == 0){
                    this.cartSize = data.obj.count
                    console.log(this.cartSize);
                }else{
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: data.msg
                    })
                }
            }).catch(e => {
                console.log(e)
            })
        }
    },
    created(){
        // if(this.$token) {
        //     this.getCartSize()
        // }
        // if()
        if(this.getterUserData()) {
            // this.isLogin = true
            // this.getCartSize()
            // this.userData = this.getterUserData()
        }else{
            // this.isLogin = false
        }
        
        
        
    }
}



// WEBPACK FOOTER //
// ./src/components/vHeader.vue